import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Good, GoodCreate, GetParams, GetResponse, PostResponse} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class GoodService {
  /** URLs principales relacionadas con Good **/
  goodUrl = environment.coreApiBaseUrl + '/api/good';
  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar Good **/
  getGood(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.goodUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createGood(newGood: FormData): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.goodUrl, newGood);
  }

  updateGood(good: FormData): Observable<any> {
    return this.http.put(this.goodUrl, good);
  }

  deleteGood(ids: number[]): Observable<any> {
    return this.http.delete(this.goodUrl, {body:{ids}});
  }
}
